/**
 * 格式化工具函數
 */

/**
 * 格式化價格顯示
 * @param {number} amount - 金額
 * @param {string} currency - 貨幣符號
 * @returns {string} - 格式化後的價格
 */
export function formatPrice(amount, currency = 'NT$') {
  if (typeof amount !== 'number' || isNaN(amount)) {
    return `${currency}0`;
  }
  return `${currency}${amount.toLocaleString('zh-TW')}`;
}

/**
 * 格式化數字
 * @param {number} num - 數字
 * @returns {string} - 格式化後的數字
 */
export function formatNumber(num) {
  if (typeof num !== 'number' || isNaN(num)) {
    return '0';
  }
  return num.toLocaleString('zh-TW');
}
